/**
 * Wave 10: Country SEO i18n — CHINA PRIORITY + remaining gaps
 * Adds full 16-language coverage for China, Hong Kong, Taiwan
 * Plus remaining language gaps for existing countries
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE10: CountrySEOMap = {

  china: {
    zh: {
      title: '中国呼叫中心 | 中文客服外包 24/7 | Call IT Dev',
      description: '中国呼叫中心外包：普通话和粤语座席，覆盖24/7，CSAT 95%，极具竞争力的价格。',
      heroTitle: '中国呼叫中心 — 全球化中文客服支持',
      heroSubtitle: '以极具竞争力的价格提供优质中文客户体验。覆盖中国大陆、香港、台湾市场。',
    },
    en: {
      title: 'Call Center China | Mandarin Customer Service Outsourcing | Call IT Dev',
      description: 'Call center for China: Mandarin & Cantonese agents, 24/7 coverage, CSAT 95%. Serving mainland China, Hong Kong, Taiwan markets.',
      heroTitle: 'Call Center for China — Mandarin & Cantonese Support',
      heroSubtitle: 'Premium Chinese-language customer experience at competitive rates. Cover mainland, HK, and Taiwan markets.',
    },
    fr: {
      title: 'Centre d\'appel Chine | Service Client en Mandarin 24/7 | Call IT Dev',
      description: 'Centre d\'appel pour la Chine : agents mandarinophones et cantonais, CSAT 95%, couverture 24/7.',
      heroTitle: 'Centre d\'appel pour la Chine — Support Mandarin et Cantonais',
      heroSubtitle: 'Service client premium en chinois à prix compétitifs. Couverture Chine continentale, Hong Kong, Taïwan.',
    },
    es: {
      title: 'Call Center China | Atención al Cliente en Mandarín | Call IT Dev',
      description: 'Call center para China: agentes en mandarín y cantonés, CSAT 95%, cobertura 24/7.',
      heroTitle: 'Call Center para China — Soporte en Mandarín y Cantonés',
      heroSubtitle: 'Experiencia de cliente premium en chino a precios competitivos.',
    },
    de: {
      title: 'Callcenter China | Mandarin Kundenservice 24/7 | Call IT Dev',
      description: 'Callcenter für China: Mandarin- und Kantonesisch-Agenten, CSAT 95%, 24/7-Abdeckung.',
      heroTitle: 'Callcenter für China — Mandarin- und Kantonesisch-Support',
      heroSubtitle: 'Premium-Kundenservice auf Chinesisch zu wettbewerbsfähigen Preisen.',
    },
    ar: {
      title: 'مركز اتصال الصين | خدمة عملاء بالصينية 24/7 | Call IT Dev',
      description: 'مركز اتصال للصين: وكلاء بالماندرين والكانتونية، CSAT 95%، تغطية 24/7.',
      heroTitle: 'مركز اتصال للصين — دعم بالماندرين والكانتونية',
      heroSubtitle: 'خدمة عملاء متميزة بالصينية بأسعار تنافسية.',
    },
    ja: {
      title: '中国コールセンター | 中国語カスタマーサポート外注 | Call IT Dev',
      description: '中国向けコールセンター：普通話・広東語対応、CSAT 95%、24/7カバレッジ。',
      heroTitle: '中国向けコールセンター — 普通話・広東語サポート',
      heroSubtitle: '競争力のある価格でプレミアムな中国語顧客体験を提供。',
    },
    ko: {
      title: '중국 콜센터 | 중국어 고객 서비스 아웃소싱 | Call IT Dev',
      description: '중국 콜센터: 만다린 및 광둥어 상담원, CSAT 95%, 24/7 커버리지.',
      heroTitle: '중국 콜센터 — 만다린 및 광둥어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 프리미엄 중국어 고객 경험을 제공합니다.',
    },
    it: {
      title: 'Call Center Cina | Servizio Clienti in Mandarino 24/7 | Call IT Dev',
      description: 'Call center per la Cina: agenti in mandarino e cantonese, CSAT 95%, copertura 24/7.',
      heroTitle: 'Call Center per la Cina — Supporto in Mandarino e Cantonese',
      heroSubtitle: 'Esperienza cliente premium in cinese a prezzi competitivi.',
    },
    pt: {
      title: 'Call Center China | Atendimento ao Cliente em Mandarim | Call IT Dev',
      description: 'Call center para China: agentes em mandarim e cantonês, CSAT 95%, cobertura 24/7.',
      heroTitle: 'Call Center para China — Suporte em Mandarim e Cantonês',
      heroSubtitle: 'Experiência premium em chinês a preços competitivos.',
    },
    nl: {
      title: 'Callcenter China | Mandarijn Klantenservice 24/7 | Call IT Dev',
      description: 'Callcenter voor China: Mandarijn- en Kantonese agenten, CSAT 95%, 24/7 dekking.',
      heroTitle: 'Callcenter voor China — Mandarijn en Kantonees Support',
      heroSubtitle: 'Premium klantenservice in het Chinees tegen concurrerende prijzen.',
    },
    pl: {
      title: 'Call Center Chiny | Obsługa Klienta po Mandaryńsku 24/7 | Call IT Dev',
      description: 'Call center dla Chin: agenci po mandaryńsku i kantońsku, CSAT 95%, pokrycie 24/7.',
      heroTitle: 'Call Center dla Chin — Wsparcie po Mandaryńsku i Kantońsku',
      heroSubtitle: 'Premiumowa obsługa klienta po chińsku w konkurencyjnych cenach.',
    },
    tr: {
      title: 'Çin Çağrı Merkezi | Mandarin Müşteri Hizmetleri | Call IT Dev',
      description: 'Çin için çağrı merkezi: Mandarin ve Kantonca ajanlar, CSAT %95, 7/24 kapsam.',
      heroTitle: 'Çin İçin Çağrı Merkezi — Mandarin ve Kantonca Destek',
      heroSubtitle: 'Rekabetçi fiyatlarla premium Çince müşteri deneyimi.',
    },
    ru: {
      title: 'Колл-центр Китай | Клиентский сервис на мандаринском 24/7 | Call IT Dev',
      description: 'Колл-центр для Китая: агенты на мандаринском и кантонском, CSAT 95%, покрытие 24/7.',
      heroTitle: 'Колл-центр для Китая — Поддержка на мандаринском и кантонском',
      heroSubtitle: 'Премиум-обслуживание клиентов на китайском по конкурентным ценам.',
    },
    sv: {
      title: 'Callcenter Kina | Mandarin Kundtjänst 24/7 | Call IT Dev',
      description: 'Callcenter för Kina: mandarin- och kantonesisktalande agenter, CSAT 95%, 24/7 täckning.',
      heroTitle: 'Callcenter för Kina — Mandarin och Kantonesiskt Stöd',
      heroSubtitle: 'Premium kundtjänst på kinesiska till konkurrenskraftiga priser.',
    },
    da: {
      title: 'Callcenter Kina | Mandarin Kundeservice 24/7 | Call IT Dev',
      description: 'Callcenter til Kina: mandarin- og kantonesisktalende agenter, CSAT 95%, 24/7 dækning.',
      heroTitle: 'Callcenter til Kina — Mandarin og Kantonesisk Support',
      heroSubtitle: 'Premium kundeservice på kinesisk til konkurrencedygtige priser.',
    },
  },

  hongkong: {
    zh: {
      title: '香港呼叫中心 | 粤语英语客服外包 | Call IT Dev',
      description: '香港呼叫中心外包：粤语和英语座席，金融服务专业支持，CSAT 95%。',
      heroTitle: '香港呼叫中心 — 粤语英语双语支持',
      heroSubtitle: '为亚洲金融中心提供优质双语客户服务。',
    },
    en: {
      title: 'Call Center Hong Kong | Cantonese & English Support | Call IT Dev',
      description: 'Call center for Hong Kong: Cantonese & English agents, financial services expertise, CSAT 95%.',
      heroTitle: 'Call Center for Hong Kong — Bilingual Cantonese & English',
      heroSubtitle: 'Premium bilingual customer service for Asia\'s financial hub.',
    },
    fr: {
      title: 'Centre d\'appel Hong Kong | Support Cantonais et Anglais | Call IT Dev',
      description: 'Centre d\'appel pour Hong Kong : agents cantonais et anglophones, expertise services financiers.',
      heroTitle: 'Centre d\'appel pour Hong Kong — Support Bilingue',
      heroSubtitle: 'Service client premium bilingue pour le hub financier asiatique.',
    },
    ja: {
      title: '香港コールセンター | 広東語・英語サポート | Call IT Dev',
      description: '香港向けコールセンター：広東語・英語エージェント、金融サービス専門。',
      heroTitle: '香港コールセンター — 広東語・英語バイリンガルサポート',
      heroSubtitle: 'アジアの金融ハブ向けプレミアムバイリンガルサービス。',
    },
    ko: {
      title: '홍콩 콜센터 | 광둥어 & 영어 지원 | Call IT Dev',
      description: '홍콩 콜센터: 광둥어 및 영어 상담원, 금융 서비스 전문.',
      heroTitle: '홍콩 콜센터 — 광둥어 & 영어 이중 언어 지원',
      heroSubtitle: '아시아 금융 허브를 위한 프리미엄 이중 언어 서비스.',
    },
    de: {
      title: 'Callcenter Hongkong | Kantonesisch & Englisch Support | Call IT Dev',
      description: 'Callcenter für Hongkong: Kantonesisch- und Englisch-Agenten, Finanzdienstleistungen.',
      heroTitle: 'Callcenter für Hongkong — Zweisprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für Asiens Finanzzentrum.',
    },
    ar: {
      title: 'مركز اتصال هونغ كونغ | دعم كانتوني وإنجليزي | Call IT Dev',
      description: 'مركز اتصال لهونغ كونغ: وكلاء بالكانتونية والإنجليزية، خبرة في الخدمات المالية.',
      heroTitle: 'مركز اتصال لهونغ كونغ — دعم ثنائي اللغة',
      heroSubtitle: 'خدمة عملاء متميزة للمركز المالي الآسيوي.',
    },
    sv: {
      title: 'Callcenter Hongkong | Kantonesisk & Engelsk Support | Call IT Dev',
      description: 'Callcenter för Hongkong: kantonesisk- och engelsktalande agenter.',
      heroTitle: 'Callcenter för Hongkong — Tvåspråkig Support',
      heroSubtitle: 'Premium kundtjänst för Asiens finanscentrum.',
    },
    da: {
      title: 'Callcenter Hongkong | Kantonesisk & Engelsk Support | Call IT Dev',
      description: 'Callcenter til Hongkong: kantonesisk- og engelsktalende agenter.',
      heroTitle: 'Callcenter til Hongkong — Tosproget Support',
      heroSubtitle: 'Premium kundeservice for Asiens finanscentrum.',
    },
  },

  taiwan: {
    zh: {
      title: '台湾呼叫中心 | 中文客服外包 | Call IT Dev',
      description: '台湾呼叫中心外包：普通话座席，科技产业专业支持，CSAT 95%。',
      heroTitle: '台湾呼叫中心 — 中文客服支持',
      heroSubtitle: '为台湾科技产业提供优质客户服务。',
    },
    en: {
      title: 'Call Center Taiwan | Mandarin Customer Service | Call IT Dev',
      description: 'Call center for Taiwan: Mandarin agents, tech industry expertise, CSAT 95%.',
      heroTitle: 'Call Center for Taiwan — Mandarin Support',
      heroSubtitle: 'Premium Mandarin customer service for Taiwan\'s tech industry.',
    },
    fr: {
      title: 'Centre d\'appel Taïwan | Service Client en Mandarin | Call IT Dev',
      description: 'Centre d\'appel pour Taïwan : agents mandarinophones, expertise industrie tech.',
      heroTitle: 'Centre d\'appel pour Taïwan — Support Mandarin',
      heroSubtitle: 'Service client premium en mandarin pour l\'industrie tech taïwanaise.',
    },
    ja: {
      title: '台湾コールセンター | 中国語カスタマーサポート | Call IT Dev',
      description: '台湾向けコールセンター：北京語エージェント、テック業界専門。',
      heroTitle: '台湾コールセンター — 中国語サポート',
      heroSubtitle: '台湾のテック産業向けプレミアム中国語サービス。',
    },
    ko: {
      title: '대만 콜센터 | 만다린 고객 서비스 | Call IT Dev',
      description: '대만 콜센터: 만다린 상담원, 기술 산업 전문.',
      heroTitle: '대만 콜센터 — 만다린 지원',
      heroSubtitle: '대만 기술 산업을 위한 프리미엄 만다린 서비스.',
    },
    de: {
      title: 'Callcenter Taiwan | Mandarin Kundenservice | Call IT Dev',
      description: 'Callcenter für Taiwan: Mandarin-Agenten, Tech-Industrie-Expertise.',
      heroTitle: 'Callcenter für Taiwan — Mandarin-Support',
      heroSubtitle: 'Premium-Kundenservice auf Mandarin für Taiwans Tech-Industrie.',
    },
    sv: {
      title: 'Callcenter Taiwan | Mandarin Kundtjänst | Call IT Dev',
      description: 'Callcenter för Taiwan: mandarintalande agenter, teknikexpertis.',
      heroTitle: 'Callcenter för Taiwan — Mandarinstöd',
      heroSubtitle: 'Premium kundtjänst på mandarin för Taiwans teknikindustri.',
    },
    da: {
      title: 'Callcenter Taiwan | Mandarin Kundeservice | Call IT Dev',
      description: 'Callcenter til Taiwan: mandarintalende agenter, teknologiekspertise.',
      heroTitle: 'Callcenter til Taiwan — Mandarinsupport',
      heroSubtitle: 'Premium kundeservice på mandarin for Taiwans teknologiindustri.',
    },
    ar: {
      title: 'مركز اتصال تايوان | خدمة عملاء بالماندرين | Call IT Dev',
      description: 'مركز اتصال لتايوان: وكلاء بالماندرين، خبرة في صناعة التكنولوجيا.',
      heroTitle: 'مركز اتصال لتايوان — دعم بالماندرين',
      heroSubtitle: 'خدمة عملاء متميزة بالماندرين لصناعة التكنولوجيا التايوانية.',
    },
  },

  // Fill remaining language gaps for major countries
  singapore: {
    zh: {
      title: '新加坡呼叫中心 | 多语种客服外包 | Call IT Dev',
      description: '新加坡呼叫中心外包：英语、中文、马来语座席，CSAT 95%，24/7覆盖。',
      heroTitle: '新加坡呼叫中心 — 多语种支持',
      heroSubtitle: '以竞争力价格为新加坡提供优质多语种客户服务。',
    },
    ja: {
      title: 'シンガポールコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'シンガポール向けコールセンター：英語・中国語・マレー語、CSAT 95%。',
      heroTitle: 'シンガポールコールセンター — 多言語サポート',
      heroSubtitle: '競争力のある価格でシンガポールに多言語カスタマーサービスを。',
    },
    ko: {
      title: '싱가포르 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '싱가포르 콜센터: 영어, 중국어, 말레이어 상담원, CSAT 95%.',
      heroTitle: '싱가포르 콜센터 — 다국어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 싱가포르에 다국어 고객 서비스를 제공.',
    },
    sv: {
      title: 'Callcenter Singapore | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Singapore: engelska, kinesiska, malayiska agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Singapore — Flerspråkigt Stöd',
      heroSubtitle: 'Premium flerspråkig kundtjänst till konkurrenskraftiga priser.',
    },
    da: {
      title: 'Callcenter Singapore | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Singapore: engelske, kinesiske, malajiske agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Singapore — Flersproget Support',
      heroSubtitle: 'Premium flersproget kundeservice til konkurrencedygtige priser.',
    },
  },

  japan: {
    zh: {
      title: '日本呼叫中心 | 日语客服外包 24/7 | Call IT Dev',
      description: '日本呼叫中心外包：日语座席，CSAT 95%，24/7覆盖，极具竞争力的价格。',
      heroTitle: '日本呼叫中心 — 日语母语支持',
      heroSubtitle: '以竞争力价格为日本市场提供优质日语客户服务。',
    },
    ko: {
      title: '일본 콜센터 | 일본어 고객 서비스 아웃소싱 | Call IT Dev',
      description: '일본 콜센터: 일본어 원어민 상담원, CSAT 95%, 24/7 커버리지.',
      heroTitle: '일본 콜센터 — 일본어 원어민 지원',
      heroSubtitle: '경쟁력 있는 가격으로 일본 시장에 프리미엄 일본어 고객 서비스를 제공.',
    },
  },

  southkorea: {
    zh: {
      title: '韩国呼叫中心 | 韩语客服外包 | Call IT Dev',
      description: '韩国呼叫中心外包：韩语座席，CSAT 95%，24/7覆盖。',
      heroTitle: '韩国呼叫中心 — 韩语支持',
      heroSubtitle: '以竞争力价格为韩国市场提供优质韩语客户服务。',
    },
    ja: {
      title: '韓国コールセンター | 韓国語カスタマーサポート | Call IT Dev',
      description: '韓国向けコールセンター：韓国語ネイティブ、CSAT 95%、24/7。',
      heroTitle: '韓国コールセンター — 韓国語サポート',
      heroSubtitle: '競争力のある価格で韓国市場にプレミアム韓国語サービスを。',
    },
    sv: {
      title: 'Callcenter Sydkorea | Koreansk Kundtjänst | Call IT Dev',
      description: 'Callcenter för Sydkorea: koreansktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Sydkorea — Koreanskt Stöd',
      heroSubtitle: 'Premium kundtjänst på koreanska till konkurrenskraftiga priser.',
    },
    da: {
      title: 'Callcenter Sydkorea | Koreansk Kundeservice | Call IT Dev',
      description: 'Callcenter til Sydkorea: koreansktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Sydkorea — Koreansk Support',
      heroSubtitle: 'Premium kundeservice på koreansk til konkurrencedygtige priser.',
    },
  },

  mexico: {
    zh: {
      title: '墨西哥呼叫中心 | 西班牙语客服外包 | Call IT Dev',
      description: '墨西哥呼叫中心外包：西班牙语座席，覆盖拉美市场，CSAT 95%。',
      heroTitle: '墨西哥呼叫中心 — 西班牙语支持',
      heroSubtitle: '以竞争力价格为墨西哥和拉美市场提供优质西班牙语服务。',
    },
    ja: {
      title: 'メキシココールセンター | スペイン語カスタマーサポート | Call IT Dev',
      description: 'メキシコ向けコールセンター：スペイン語ネイティブ、CSAT 95%。',
      heroTitle: 'メキシココールセンター — スペイン語サポート',
      heroSubtitle: '競争力のある価格でメキシコ市場にスペイン語サービスを。',
    },
    ko: {
      title: '멕시코 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '멕시코 콜센터: 스페인어 원어민 상담원, CSAT 95%.',
      heroTitle: '멕시코 콜센터 — 스페인어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 멕시코 시장에 스페인어 서비스를 제공.',
    },
    sv: {
      title: 'Callcenter Mexiko | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Mexiko: spansktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Mexiko — Spanskt Stöd',
      heroSubtitle: 'Premium kundtjänst på spanska till konkurrenskraftiga priser.',
    },
    da: {
      title: 'Callcenter Mexico | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Mexico: spansktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Mexico — Spansk Support',
      heroSubtitle: 'Premium kundeservice på spansk til konkurrencedygtige priser.',
    },
  },

  colombia: {
    zh: {
      title: '哥伦比亚呼叫中心 | 西班牙语客服外包 | Call IT Dev',
      description: '哥伦比亚呼叫中心外包：西班牙语座席，CSAT 95%。',
      heroTitle: '哥伦比亚呼叫中心 — 西班牙语支持',
      heroSubtitle: '为哥伦比亚市场提供优质客户服务。',
    },
    ja: {
      title: 'コロンビアコールセンター | スペイン語サポート | Call IT Dev',
      description: 'コロンビア向けコールセンター：スペイン語ネイティブ、CSAT 95%。',
      heroTitle: 'コロンビアコールセンター — スペイン語サポート',
      heroSubtitle: '競争力のある価格でプレミアムスペイン語サービスを。',
    },
    ko: {
      title: '콜롬비아 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '콜롬비아 콜센터: 스페인어 상담원, CSAT 95%.',
      heroTitle: '콜롬비아 콜센터 — 스페인어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 프리미엄 스페인어 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Colombia | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Colombia: spansktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Colombia — Spanskt Stöd',
      heroSubtitle: 'Premium kundtjänst på spanska till konkurrenskraftiga priser.',
    },
    da: {
      title: 'Callcenter Colombia | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Colombia: spansktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Colombia — Spansk Support',
      heroSubtitle: 'Premium kundeservice på spansk til konkurrencedygtige priser.',
    },
  },

  vietnam: {
    zh: {
      title: '越南呼叫中心 | 越南语客服外包 | Call IT Dev',
      description: '越南呼叫中心外包：越南语座席，CSAT 95%，极具竞争力的价格。',
      heroTitle: '越南呼叫中心 — 越南语支持',
      heroSubtitle: '以极具竞争力的价格为越南市场提供客户服务。',
    },
    ja: {
      title: 'ベトナムコールセンター | ベトナム語サポート | Call IT Dev',
      description: 'ベトナム向けコールセンター：ベトナム語ネイティブ、CSAT 95%。',
      heroTitle: 'ベトナムコールセンター — ベトナム語サポート',
      heroSubtitle: '競争力のある価格でベトナム市場にサービスを。',
    },
    ko: {
      title: '베트남 콜센터 | 베트남어 고객 서비스 | Call IT Dev',
      description: '베트남 콜센터: 베트남어 상담원, CSAT 95%.',
      heroTitle: '베트남 콜센터 — 베트남어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 베트남 시장에 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Vietnam | Vietnamesisk Kundtjänst | Call IT Dev',
      description: 'Callcenter för Vietnam: vietnamesisktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Vietnam — Vietnamesiskt Stöd',
      heroSubtitle: 'Premium kundtjänst till konkurrenskraftiga priser.',
    },
    da: {
      title: 'Callcenter Vietnam | Vietnamesisk Kundeservice | Call IT Dev',
      description: 'Callcenter til Vietnam: vietnamesisktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Vietnam — Vietnamesisk Support',
      heroSubtitle: 'Premium kundeservice til konkurrencedygtige priser.',
    },
  },

  philippines: {
    zh: {
      title: '菲律宾呼叫中心 | 英语客服外包 | Call IT Dev',
      description: '菲律宾呼叫中心外包：英语座席，CSAT 95%，极具竞争力的价格。',
      heroTitle: '菲律宾呼叫中心 — 英语支持',
      heroSubtitle: '以极具竞争力的价格为菲律宾市场提供英语客户服务。',
    },
    ja: {
      title: 'フィリピンコールセンター | 英語カスタマーサポート | Call IT Dev',
      description: 'フィリピン向けコールセンター：英語ネイティブ、CSAT 95%。',
      heroTitle: 'フィリピンコールセンター — 英語サポート',
      heroSubtitle: '競争力のある価格でフィリピン市場に英語サービスを。',
    },
    ko: {
      title: '필리핀 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '필리핀 콜센터: 영어 상담원, CSAT 95%.',
      heroTitle: '필리핀 콜센터 — 영어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 영어 고객 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Filippinerna | Engelsktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Filippinerna: engelsktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Filippinerna — Engelskt Stöd',
      heroSubtitle: 'Premium kundtjänst på engelska till konkurrenskraftiga priser.',
    },
    da: {
      title: 'Callcenter Filippinerne | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Filippinerne: engelsktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Filippinerne — Engelsk Support',
      heroSubtitle: 'Premium kundeservice på engelsk til konkurrencedygtige priser.',
    },
  },

  egypt: {
    zh: {
      title: '埃及呼叫中心 | 阿拉伯语客服外包 | Call IT Dev',
      description: '埃及呼叫中心外包：阿拉伯语座席，CSAT 95%，极具竞争力的价格。',
      heroTitle: '埃及呼叫中心 — 阿拉伯语支持',
      heroSubtitle: '以极具竞争力的价格为埃及市场提供阿拉伯语客户服务。',
    },
    ja: {
      title: 'エジプトコールセンター | アラビア語サポート | Call IT Dev',
      description: 'エジプト向けコールセンター：アラビア語ネイティブ、CSAT 95%。',
      heroTitle: 'エジプトコールセンター — アラビア語サポート',
      heroSubtitle: '競争力のある価格でエジプト市場にサービスを。',
    },
    ko: {
      title: '이집트 콜센터 | 아랍어 고객 서비스 | Call IT Dev',
      description: '이집트 콜센터: 아랍어 상담원, CSAT 95%.',
      heroTitle: '이집트 콜센터 — 아랍어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 아랍어 고객 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Egypten | Arabisktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Egypten: arabisktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Egypten — Arabiskt Stöd',
      heroSubtitle: 'Premium kundtjänst på arabiska till konkurrenskraftiga priser.',
    },
    da: {
      title: 'Callcenter Egypten | Arabisktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Egypten: arabisktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Egypten — Arabisk Support',
      heroSubtitle: 'Premium kundeservice på arabisk til konkurrencedygtige priser.',
    },
  },

  nigeria: {
    zh: {
      title: '尼日利亚呼叫中心 | 英语客服外包 | Call IT Dev',
      description: '尼日利亚呼叫中心外包：英语座席，覆盖西非市场，CSAT 95%。',
      heroTitle: '尼日利亚呼叫中心 — 英语支持',
      heroSubtitle: '以竞争力价格为西非最大经济体提供客户服务。',
    },
    ja: {
      title: 'ナイジェリアコールセンター | 英語サポート | Call IT Dev',
      description: 'ナイジェリア向けコールセンター：英語ネイティブ、CSAT 95%。',
      heroTitle: 'ナイジェリアコールセンター — 英語サポート',
      heroSubtitle: '西アフリカ最大の経済大国にサービスを。',
    },
    ko: {
      title: '나이지리아 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '나이지리아 콜센터: 영어 상담원, CSAT 95%.',
      heroTitle: '나이지리아 콜센터 — 영어 지원',
      heroSubtitle: '서아프리카 최대 경제국에 고객 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Nigeria | Engelsktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Nigeria: engelsktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Nigeria — Engelskt Stöd',
      heroSubtitle: 'Premium kundtjänst för Västafrikas största ekonomi.',
    },
    da: {
      title: 'Callcenter Nigeria | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Nigeria: engelsktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Nigeria — Engelsk Support',
      heroSubtitle: 'Premium kundeservice for Vestafrikas største økonomi.',
    },
  },

  argentina: {
    zh: {
      title: '阿根廷呼叫中心 | 西班牙语客服外包 | Call IT Dev',
      description: '阿根廷呼叫中心外包：西班牙语座席，CSAT 95%。',
      heroTitle: '阿根廷呼叫中心 — 西班牙语支持',
      heroSubtitle: '以竞争力价格为阿根廷市场提供西班牙语客户服务。',
    },
    ja: {
      title: 'アルゼンチンコールセンター | スペイン語サポート | Call IT Dev',
      description: 'アルゼンチン向けコールセンター：スペイン語ネイティブ、CSAT 95%。',
      heroTitle: 'アルゼンチンコールセンター — スペイン語サポート',
      heroSubtitle: '競争力のある価格でアルゼンチン市場にサービスを。',
    },
    ko: {
      title: '아르헨티나 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '아르헨티나 콜센터: 스페인어 상담원, CSAT 95%.',
      heroTitle: '아르헨티나 콜센터 — 스페인어 지원',
      heroSubtitle: '경쟁력 있는 가격으로 아르헨티나에 서비스 제공.',
    },
    sv: {
      title: 'Callcenter Argentina | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Argentina: spansktalande agenter, CSAT 95%.',
      heroTitle: 'Callcenter för Argentina — Spanskt Stöd',
      heroSubtitle: 'Premium kundtjänst på spanska till konkurrenskraftiga priser.',
    },
    da: {
      title: 'Callcenter Argentina | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Argentina: spansktalende agenter, CSAT 95%.',
      heroTitle: 'Callcenter til Argentina — Spansk Support',
      heroSubtitle: 'Premium kundeservice på spansk til konkurrencedygtige priser.',
    },
  },
};
